export function getRemPropertyPixelSize(
  element: HTMLElement,
  propertyName: string,
): number {
  const rootFontSize = getRootFontSize();
  const fontSizeRem = parseFloat(
    window.getComputedStyle(element).getPropertyValue(propertyName),
  );
  return fontSizeRem * rootFontSize;
}

export function getRemPixelSize(rem: number): number {
  const rootFontSize = getRootFontSize();
  return rem * rootFontSize;
}

function getRootFontSize(): number {
  return parseFloat(
    getComputedStyle(document.documentElement).getPropertyValue('font-size'),
  );
}
